import { render, staticRenderFns } from "./FilesErrorsList.vue?vue&type=template&id=45856c6f&"
import script from "./FilesErrorsList.vue?vue&type=script&lang=js&"
export * from "./FilesErrorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports